import { OAuthStorage } from 'angular-oauth2-oidc';
import { MemoryStorageMock } from './memory-storage-mock';

export const PLUGIN_URL_MARKERS = ['coyo-plugin', 'staffbase-plugin', 'iframe-plugin', 'unily-plugin'] as const;

export function createDefaultLogger(): Console {
  return console;
}

/**
 * Tokens are kept in localStorage (session survival across tabs/reloads);
 * upstream's default would be sessionStorage. Plugin contexts get a no-op
 * storage so no tokens are ever persisted inside third-party iframes.
 */
export function createDefaultStorage(): OAuthStorage {
  if (PLUGIN_URL_MARKERS.some((marker) => window.location.href.includes(marker))) {
    return new MemoryStorageMock();
  }
  return localStorage;
}
